import { ApplicationCase } from '../../lib/models/api/application-case.model';
import { PropositionInterfaceType } from '../../lib/models/api/proposition-interface-type.model';
import { Deserializable } from '../../lib/models/deserializable';
import { GridPageOptions } from '../../lib/models/dto/case-search/grid-page-options.model';

export class ProductPickerFilterDto implements Deserializable {
  public PurchaseOrRemortgageCode: string;
  public PropertyLocationCode: string;
  public LoanGroupTypeCode: string;
  public GridPageOptions: GridPageOptions;
  public PrepopulatedProductID: string;
  public PropositionInterfaceType: PropositionInterfaceType;
  public IsResidential: boolean;
  public InterestOnlyQuestionCode: string;

  public mapCaseData(appCase: ApplicationCase): ProductPickerFilterDto {
    this.GridPageOptions = new GridPageOptions();
    this.PurchaseOrRemortgageCode = appCase.PurchaseOrRemortgageCode;
    this.PropertyLocationCode = appCase.PropertyLocationCode;
    this.LoanGroupTypeCode = appCase.LoanGroupTypeCode;
    this.IsResidential = appCase.IsResidential;
    this.InterestOnlyQuestionCode = appCase.EligibilityInterestOnlyAnswerCode;
    this.PropositionInterfaceType = new PropositionInterfaceType();
    this.PropositionInterfaceType.PropositionId = appCase.PropositionIDCache;
    this.PropositionInterfaceType.InterfaceTypeId = appCase.InterfaceTypeIDCache;

    return this;
  }

  public deserialize(input: any): this {
    Object.assign(this, input);
    this.GridPageOptions = new GridPageOptions().deserialize(input.GridPageOptions);
    this.PropositionInterfaceType = new PropositionInterfaceType().deserialize(input.PropositionInterfaceType);

    return this;
  }
}
